import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CLAIMS_TOTAL_COUNTS_TYPES, OVERCHARGE_CLAIMS_FILTERS_INITIAL_DATA } from '../../../../contants/ClaimsEnums';
import { SEARCH_VIEW_TYPES } from '../../../../contants/common';
import {
  deleteOverChargeClaimsInProgress,
  getOverChargeClaimDetailsInProgress,
  getOverChargeClamsListInProgress,
  setClaimsOverChargeFilters,
  setOverChargeClaimsEditDrawer,
  setOverchargeList,
  setSelectedOverChargeClaims,
} from '../../../../redux/Claims/OverCharge/OverChargeActions';
import EmptyRecords from '../../../components/Common/EmptyRecords';
import ScrollPagination from '../../../components/Paginations/ScrollPagination';
import Paper from '../../../components/Paper/Paper';
import { CLAIMS_FOOTER_TYPES } from '../constants';
import OverChargeEditDrawer from './Components/Edit/Drawer/OverChargeEditDrawer';
import OverChargeCard from './Components/OverChargeCard';
import OCClaimTableView from './List/OCClaimTableView';

const OverChargeClaimsContent = () => {
  const dispatch = useDispatch();
  const selectedCompany = useSelector((state) => state.auth.selectedCompany);
  const { claimsList, claimsFilters, selectedClaims, claimViewMode } = useSelector((state) => state.overChargeClaims);

  const handleCardClick = (fbocKey) => () => {
    dispatch(setOverChargeClaimsEditDrawer(true));
    dispatch(getOverChargeClaimDetailsInProgress(fbocKey));
  };

  const totalPageCount = useMemo(() => {
    const footerParam =
      CLAIMS_TOTAL_COUNTS_TYPES[claimsFilters.FooterStatus] === CLAIMS_TOTAL_COUNTS_TYPES[CLAIMS_FOOTER_TYPES.ALL]
        ? CLAIMS_TOTAL_COUNTS_TYPES.ALL_FOR_OC_CLAIM
        : CLAIMS_TOTAL_COUNTS_TYPES[claimsFilters.FooterStatus];

    return Math.floor((claimsList?.[footerParam] + (claimsFilters.pageSize - 1)) / claimsFilters.pageSize);
  }, [claimsList, claimsFilters]);

  const handleLoadMore = () => {
    dispatch(
      setClaimsOverChargeFilters({
        ...claimsFilters,
        pageNo: claimsFilters.pageNo + 1,
      }),
    );
    dispatch(getOverChargeClamsListInProgress());
  };

  const onSelect = (id, remove) => {
    const selectedClaimsLocal = [...selectedClaims];
    if (!remove) {
      selectedClaimsLocal.push(id);
    } else {
      const index = selectedClaimsLocal.indexOf(id);
      selectedClaimsLocal.splice(index, 1);
    }
    dispatch(setSelectedOverChargeClaims(selectedClaimsLocal));
  };

  const handleDelete = (fbocKey) => {
    dispatch(
      deleteOverChargeClaimsInProgress({
        fbocKeys: String(fbocKey),
      }),
    );
  };

  useEffect(() => {
    if (selectedCompany?.companyId) {
      dispatch(
        setClaimsOverChargeFilters({
          ...OVERCHARGE_CLAIMS_FILTERS_INITIAL_DATA,
          pageNo: 1,
        }),
      );
      dispatch(setOverchargeList({ data: [], isFirstTime: true }));
    }
  }, [selectedCompany?.companyId]);

  const isCardView = useMemo(() => claimViewMode === SEARCH_VIEW_TYPES.CARD, [claimViewMode]);

  return (
    <div className="py-15 h-100 ">
      {isCardView ? (
        <>
          {claimsList?.isFirstTime ? (
            <Paper className="h-100 w-100 mb-15" />
          ) : (
            <ScrollPagination
              className={`${claimsList?.data?.length > 0 ? 'mb-15' : 'pb-15'} h-100 `}
              loadMore={handleLoadMore}
              hasMore={claimsList.progressing ? false : claimsFilters?.pageNo < totalPageCount}
              isLoading={claimsList.progressing}
              scrollOffset={50}
            >
              {claimsList?.data && claimsList?.data.length > 0 ? (
                claimsList?.data.map((row) => (
                  <div className="mb-15" key={row.fbocKey}>
                    <OverChargeCard
                      data={row}
                      onSelect={onSelect}
                      handleCardClick={handleCardClick}
                      isSelected={selectedClaims.includes(row.fbocKey)}
                      handleDelete={handleDelete}
                    />
                  </div>
                ))
              ) : (
                <>{!claimsList.progressing && <EmptyRecords />}</>
              )}
            </ScrollPagination>
          )}
        </>
      ) : (
        <OCClaimTableView
          handleLoadMore={handleLoadMore}
          isLoading={claimsList.progressing}
          hasMore={claimsList.progressing ? false : claimsFilters?.pageNo < totalPageCount}
          claimsList={claimsList?.data ? claimsList.data : []}
          handleCardClick={handleCardClick}
          onSelect={onSelect}
          selectedClaims={selectedClaims}
          handleDelete={handleDelete}
          isFirstTime={claimsList?.isFirstTime}
        />
      )}
      <OverChargeEditDrawer />
    </div>
  );
};

export default OverChargeClaimsContent;
